import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const ocShowEmployeeNameState = atom({
  key: "ocShowEmployeeNameState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
